import FeatureDisabled from "./FeatureDisabled";

export default FeatureDisabled;